import { atom } from "jotai";

export const showSidebarFlagAtom = atom(false);
